import {useEffect, useState} from 'react';

interface UseVisibilityProps {
  onFocus?: () => void;
  onBlur?: () => void;
  isInitiallyEnabled?: boolean;
}

function useWindowFocusTracker({onFocus, onBlur, isInitiallyEnabled = true}: UseVisibilityProps) {
  const [isWindowFocusTrackerEnabled, setIsWindowFocusTrackerEnabled] = useState<boolean>(isInitiallyEnabled);

  function disableWindowFocusTracker() {
    setIsWindowFocusTrackerEnabled(false);
  }

  function enableWindowFocusTracker() {
    setIsWindowFocusTrackerEnabled(true);
  }

  useEffect(() => {
    function handleVisibility() {
      if (document.visibilityState === 'visible') {
        isWindowFocusTrackerEnabled && onFocus?.();
      }
      if (document.visibilityState === 'hidden') {
        isWindowFocusTrackerEnabled && onBlur?.();
      }
    }

    document.addEventListener('visibilitychange', handleVisibility);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [isWindowFocusTrackerEnabled]);

  return {
    isWindowFocusTrackerEnabled,
    enableWindowFocusTracker,
    disableWindowFocusTracker,
  };
}

export default useWindowFocusTracker;
